import request from '@/router/axios'

export function queryList(query) {
	return request({
		url: '/dist/maintenance/page',
		method: 'get',
		params: query,
	})
}

//查询登录页员工完成情况
export function queryCompletionList(query) {
	return request({
		url: '/dist/maintenance/user/list',
		method: 'get',
		params: query,
	})
}

export function queryDic(params) {
	return request({
		url: '/dist/material/type/config',
		method: 'get',
		params: params,
	})
}

export function delObj(id) {
	return request({
		url: '/dist/maintenance/' + id,
		method: 'delete',
	})
}

export function addObj(obj) {
	return request({
		url: '/dist/maintenance',
		method: 'post',
		data: obj,
	})
}

export function completedMaintenance(obj) {
	return request({
		url: '/dist/maintenance/user',
		method: 'post',
		data: obj,
	})
}

export function putObj(obj) {
	return request({
		url: '/dist/maintenance',
		method: 'put',
		data: obj,
	})
}
